/* Proutdoor · Barra de compra en celular (nov 2026). Mejora 2 del informe.
   Usa el precio y el botón reales del producto: no agrega al carro por su cuenta.
   Aparece cuando ni el precio ni el botón están en pantalla. */
(function () {
  const celular = window.matchMedia('(max-width: 768.98px)');
  const main = document.querySelector('#main-content');
  if (!main) return;

  const form = () => main.querySelector('.js-product-form-main');
  const boton = () => form()?.querySelector('[type="submit"]');
  const precio = () => main.querySelector('.product-info .price__current .js-value');
  const selector = () => main.querySelector('variant-picker');
  if (!boton()) return;

  // Con talla o medida, la primera vez se lleva a elegir: el botón directo agregaría la opción por defecto.
  let eligio = new URLSearchParams(location.search).has('variant');
  // El carro lateral tarda unos segundos en abrirse: mientras tanto, la barra avisa que está agregando.
  let agregando = false;

  const barra = document.createElement('div');
  barra.className = 'pt-barra';
  barra.setAttribute('role', 'region');
  barra.setAttribute('aria-label', 'Comprar este producto');
  const textoPrecio = document.createElement('span');
  textoPrecio.className = 'pt-barra__precio';
  const accion = document.createElement('button');
  accion.type = 'button';
  accion.className = 'pt-barra__btn btn btn--primary';
  barra.append(textoPrecio, accion);
  document.body.append(barra);

  const enPantalla = (el) => {
    if (!el) return false;
    const r = el.getBoundingClientRect();
    return r.height > 0 && r.bottom > 0 && r.top < window.innerHeight;
  };
  const debeElegir = () => selector() && !eligio;

  const actualizar = () => {
    const b = boton();
    const p = precio();
    if (p) textoPrecio.textContent = p.textContent.trim();
    if (agregando) {
      accion.textContent = 'Agregando…';
    } else if (b) {
      accion.textContent = debeElegir() ? 'Elegir opción' : b.innerText.trim();
    }
    accion.disabled = agregando;
    const visible = celular.matches && b && !b.disabled && !enPantalla(b) && !enPantalla(p);
    barra.classList.toggle('is-on', Boolean(visible));
    document.body.classList.toggle('pt-barra-on', Boolean(visible));
  };

  let pendiente = false;
  const programar = () => {
    if (pendiente) return;
    pendiente = true;
    requestAnimationFrame(() => {
      pendiente = false;
      actualizar();
    });
  };

  const terminar = () => {
    agregando = false;
    programar();
  };

  accion.addEventListener('click', () => {
    if (debeElegir()) {
      selector().scrollIntoView({ behavior: 'smooth', block: 'center' });
    } else if (boton()) {
      agregando = true;
      actualizar();
      boton().click();
      setTimeout(terminar, 5000);
    }
  });

  document.addEventListener('on:cart:add', terminar);
  document.addEventListener('on:line-item:change', terminar);
  // El tema muestra el error junto al botón original: se lleva hasta ahí para que se lea.
  document.addEventListener('on:cart:error', () => {
    terminar();
    boton()?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });
  document.addEventListener('change', (e) => {
    if (e.target.closest?.('variant-picker')) {
      eligio = true;
      programar();
    }
  });
  window.addEventListener('scroll', programar, { passive: true });
  window.addEventListener('resize', programar);
  // El tema reemplaza precio y botón al cambiar de variante.
  new MutationObserver(programar).observe(main, {
    subtree: true,
    childList: true,
    characterData: true,
    attributes: true,
    attributeFilter: ['disabled']
  });
  actualizar();
})();
